var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileDesignationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4398_13527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 4.99935V4.16602C6.66797 2.7853 7.78726 1.66602 9.16797 1.66602H10.8346C12.2153 1.66602 13.3346 2.7853 13.3346 4.16602V4.99935M1.66797 8.62225C1.66797 8.62225 4.26634 10.353 8.31602 10.7584M18.3346 8.62225C18.3346 8.62225 15.7363 10.353 11.6866 10.7584M5.0013 18.3327H15.0013C16.8423 18.3327 18.3346 16.8403 18.3346 14.9993V8.33268C18.3346 6.49173 16.8423 4.99935 15.0013 4.99935H5.0013C3.16035 4.99935 1.66797 6.49173 1.66797 8.33268V14.9993C1.66797 16.8403 3.16035 18.3327 5.0013 18.3327Z",
    stroke: "#958DA5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 10.1341V10.9674C11.6654 10.9758 11.6654 10.9758 11.6654 10.9841C11.6654 11.8924 11.657 12.6341 9.9987 12.6341C8.3487 12.6341 8.33203 11.9008 8.33203 10.9924V10.1341C8.33203 9.30078 8.33203 9.30078 9.16536 9.30078H10.832C11.6654 9.30078 11.6654 9.30078 11.6654 10.1341Z",
    stroke: "#958DA5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4398_13527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDesignationIcon);
export default __webpack_public_path__ + "static/media/profile-designation-icon.09a3b6bb346cf95b1f46946b51414b9d.svg";
export { ForwardRef as ReactComponent };